//#region src/core/source/spotify.ts
/**
* Extract a Spotify entity id from any recognized URL or `spotify:` URI.
*
* @internal
*/
function parseSpotifyEntityId(src) {
	return parseSpotifySource(src)?.id ?? null;
}
/**
* Parse a Spotify source string. Recognizes `open.spotify.com` URLs for every embeddable entity — including the
* localized (`/intl-de/`) and already-embedded (`/embed/`) forms, since the entity type and id sit in the same place in
* all of them — `spotify:<type>:<id>` URIs, and start positions via the `t` parameter.
*
* @internal
*/
function parseSpotifySource(src) {
	if (!src) return null;
	const match = MATCH_URI.exec(src) ?? MATCH_SRC.exec(src);
	const type = match?.[1]?.toLowerCase();
	const id = match?.[2];
	if (!type || !id) return null;
	return {
		type,
		id,
		startTime: parseStartTime(src)
	};
}
/** Parse the `t` parameter from a Spotify share URL. Spotify spells it in seconds. */
function parseStartTime(url) {
	const value = /[?&]t=(\d+)/.exec(url)?.[1];
	return value ? Number.parseInt(value, 10) : null;
}
const MATCH_SRC = /open\.spotify\.com\/(?:[\w-]+\/)*?(track|episode|album|playlist|show|artist)\/(\w+)/i;
const MATCH_URI = /^spotify:(track|episode|album|playlist|show|artist):(\w+)$/i;
//#endregion
export { parseSpotifyEntityId, parseSpotifySource };
